export class Queue<T> {
    private items: T[] = []

    static create<T>(): Queue<T> {
        return new Queue<T>()
    }

    enqueue(item: T): void {
        this.items.push(item)
    }

    dequeue(): T | undefined {
        return this.items.shift()
    }

    pop(): T | undefined {
        return this.items.pop()
    }

    peek(): T | undefined {
        return this.items[0]
    }

    peekLast(): T | undefined {
        return this.items[this.size() - 1]
    }

    isEmpty(): boolean {
        return this.items.length === 0
    }

    size(): number {
        return this.items.length
    }

    clear(): void {
        this.items = []
    }
}
